"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties")),
    _react = _interopRequireDefault(require("react")),
    _uiKit = require("@devsta/ui-kit");

function MentionItem(_ref) {
  var _ref$mention = _ref.mention,
      name = _ref$mention.name,
      imageUrl = _ref$mention.imageUrl,
      searchValue = _ref.searchValue,
      isFocused = _ref.isFocused,
      parentProps = (0, _objectWithoutProperties2["default"])(_ref, ["mention", "searchValue", "isFocused"]),
      prefix = _react["default"].createElement(_uiKit.Image, {
    height: "20px",
    width: "20px",
    imageUrl: imageUrl,
    placeholderText: name,
    placeholderTextSize: 10,
    circular: !0,
    backgroundSize: "cover"
  });

  return _react["default"].createElement("div", (0, _extends2["default"])({}, parentProps, {
    className: "mention-item",
    role: "menuitem"
  }), _react["default"].createElement(_uiKit.DropdownLabel, {
    isUpperCase: !0,
    data: {
      prefix: prefix,
      label: name
    }
  }));
}

var _default = MentionItem;
exports["default"] = _default;